module.exports = __webpack_public_path__ + "static/media/on_site_furniture_distance.ade1d0dd.svg";